import { EVENT_KIND_LABEL } from '../../core/constants/domain';
import { toId, toText } from './list';

export function normalizeEvent(raw) {
    const kind = toText(raw?.kind, 'evento');
    return {
        id: toId(raw?.id) ?? toText(raw?.id),
        kind,
        kindLabel: EVENT_KIND_LABEL[kind] ?? kind,
        at: raw?.at ?? raw?.created_at ?? null,
        summary: toText(raw?.summary ?? raw?.task?.title, EVENT_KIND_LABEL[kind] ?? kind),
        projectId: toId(raw?.project_id),
        taskId: toId(raw?.task_id ?? raw?.task),
        actor: raw?.actor ? toText(raw.actor) : null,
    };
}

export function normalizeAttention(raw) {
    return {
        id: toText(raw?.id),
        kind: toText(raw?.kind),
        what: toText(raw?.happened?.what, 'Requiere atención'),
        detail: toText(raw?.happened?.detail),
        reason: toText(raw?.reason),
        resourceType: raw?.resource?.type ?? null,
        resourceId: toId(raw?.resource?.id),
        projectId: toId(raw?.scope?.project_id),
        validity: raw?.validity ?? null,
        at: raw?.at ?? null,
    };
}
